import { render, staticRenderFns } from "./DetailedTimeAllocator.vue?vue&type=template&id=4fd58e36"
import script from "./DetailedTimeAllocator.vue?vue&type=script&lang=js"
export * from "./DetailedTimeAllocator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports